export const ModuleId = {
  DASHBOARD: 'DASHBOARD',
  INVENTORY: 'INVENTORY',
  PURCHASE: 'PURCHASE',
  POS: 'POS',
  LOGISTICS: 'LOGISTICS',
  MASTERS: 'MASTERS',
  PAYROLL: 'PAYROLL',
  FINANCE: 'FINANCE',
  REPORTS: 'REPORTS',
  VAT: 'VAT',
  CRM: 'CRM',
  PRODUCTION: 'PRODUCTION',
  SECURITY: 'SECURITY',
  SETUP: 'SETUP',
  HUB: 'HUB',
  MYACCOUNTS_SETUP: 'MYACCOUNTS_SETUP',
  SYSTEM_MANAGER: 'SYSTEM_MANAGER',
  APP_SETUP: 'APP_SETUP',
  DATA_MGMT: 'DATA_MGMT',
  FINAL_ACCOUNTS: 'FINAL_ACCOUNTS',
  WEB_SETUP: 'WEB_SETUP',
  SETTINGS_REPORTS: 'SETTINGS_REPORTS',
  IDENTITY: 'IDENTITY',
  FAULT_AUDIT: 'FAULT_AUDIT',
  INFRA_MESH: 'INFRA_MESH',
  LICENSE_KERNEL: 'LICENSE_KERNEL',
  AUTH_GATEWAY: 'AUTH_GATEWAY',
  INFRA_GUIDE: 'INFRA_GUIDE',
  SETUP_WIZARD: 'SETUP_WIZARD',
  // ERP Modules
  ITEM_CREATION: 'ITEM_CREATION',
  PURCHASE_INVOICE: 'PURCHASE_INVOICE',
  GRN: 'GRN',
  PURCHASE_RETURN: 'PURCHASE_RETURN',
  // ULID Generator
  ULID_GENERATOR: 'ULID_GENERATOR',
  // Industry Config / Control Management
  INDUSTRY_CONFIG: 'INDUSTRY_CONFIG',
  ATTRIBUTE_STUDIO: 'ATTRIBUTE_STUDIO',
  // ERP Attribute Engine
  DYNAMIC_ATTRIBUTES: 'DYNAMIC_ATTRIBUTES',
  // Help Engine
  HELP_ENGINE: 'HELP_ENGINE',
  // Ticket Management
  TICKET_MANAGEMENT: 'TICKET_MANAGEMENT',
  TIER_PRIVILEGE_MATRIX: 'TIER_PRIVILEGE_MATRIX',
  ITEM_CREATION_NEW: 'ITEM_CREATION_NEW',
  ITEM_LIST: 'ITEM_LIST',
  // Finance Module - Masters
  CHART_OF_ACCOUNTS: 'CHART_OF_ACCOUNTS',
  FINANCE_SETTINGS: 'FINANCE_SETTINGS',
  SCHEDULE_MASTER: 'SCHEDULE_MASTER',
  PRIMARY_GROUP: 'PRIMARY_GROUP',
  GROUP_LEDGER: 'GROUP_LEDGER',
  GENERAL_LEDGER: 'GENERAL_LEDGER',
  NARRATION_MASTER: 'NARRATION_MASTER',
  DEFAULT_ACCOUNTS: 'DEFAULT_ACCOUNTS',
  REINDEX_VOUCHERS: 'REINDEX_VOUCHERS',
  OPENING_BALANCE: 'OPENING_BALANCE',
  // Finance Transactions - Receipts
  CASH_RECEIPT: 'CASH_RECEIPT',
  BANK_RECEIPT: 'BANK_RECEIPT',
  PDC_RECEIPT: 'PDC_RECEIPT',
  SALES_VOUCHER: 'SALES_VOUCHER',
  SALES_RETURN: 'SALES_RETURN',
  PETTY_CASH_RECEIPT: 'PETTY_CASH_RECEIPT',
  BILLS_ADJUSTMENT_RECEIPT: 'BILLS_ADJUSTMENT_RECEIPT',
  SALES_UPDATION: 'SALES_UPDATION',
  PDC_RECEIPT_ADJUSTMENT: 'PDC_RECEIPT_ADJUSTMENT',
  // Finance Transactions - Payments
  CASH_PAYMENT: 'CASH_PAYMENT',
  BANK_PAYMENT: 'BANK_PAYMENT',
  PDC_PAYMENT: 'PDC_PAYMENT',
  PURCHASE_VOUCHER: 'PURCHASE_VOUCHER',
  PURCHASE_RETURN_VOUCHER: 'PURCHASE_RETURN_VOUCHER',
  PETTY_CASH_PAYMENT: 'PETTY_CASH_PAYMENT',
  MATURED_PDC_VOUCHERS: 'MATURED_PDC_VOUCHERS',
  PDC_PAYMENT_ADJUSTMENT: 'PDC_PAYMENT_ADJUSTMENT',
  PURCHASE_ORDER_VOUCHER: 'PURCHASE_ORDER_VOUCHER',
  BILLS_ADJUSTMENT_PAYMENT: 'BILLS_ADJUSTMENT_PAYMENT',
  // Finance Transactions - Journal & Others
  JOURNAL_ENTRY: 'JOURNAL_ENTRY',
  DEBIT_NOTE: 'DEBIT_NOTE',
  CREDIT_NOTE: 'CREDIT_NOTE',
  CASH_DEPOSIT_WITHDRAW: 'CASH_DEPOSIT_WITHDRAW',
  // Finance Reports - Books
  DAY_BOOK: 'DAY_BOOK',
  CASH_BOOK: 'CASH_BOOK',
  BANK_BOOK: 'BANK_BOOK',
  VOUCHER_REGISTER: 'VOUCHER_REGISTER',
  // Finance Reports - Ledgers
  GENERAL_LEDGER_REPORT: 'GENERAL_LEDGER_REPORT',
  MULTIPLE_LEDGER: 'MULTIPLE_LEDGER',
  GROUP_LEDGER_REPORT: 'GROUP_LEDGER_REPORT',
  PAYMENT_LEDGER: 'PAYMENT_LEDGER',
  SUB_LEDGER: 'SUB_LEDGER',
  DAYWISE_BALANCE: 'DAYWISE_BALANCE',
  MONTHLY_BALANCE: 'MONTHLY_BALANCE',
  // Finance Reports - Financial Statements
  TRIAL_BALANCE: 'TRIAL_BALANCE',
  PROFIT_LOSS: 'PROFIT_LOSS',
  BALANCE_SHEET: 'BALANCE_SHEET',
  TRADING_ACCOUNT: 'TRADING_ACCOUNT',
  // Finance Reports - Bank
  BANK_RECONCILIATION: 'BANK_RECONCILIATION',
  PDC_RECONCILIATION: 'PDC_RECONCILIATION',
  CHEQUE_STATEMENT: 'CHEQUE_STATEMENT',
  // Finance Reports - Receivables/Payables
  OUTSTANDING_RECEIVABLES: 'OUTSTANDING_RECEIVABLES',
  OVERDUE_RECEIVABLES: 'OVERDUE_RECEIVABLES',
  OUTSTANDING_PAYABLES: 'OUTSTANDING_PAYABLES',
  OVERDUE_PAYABLES: 'OVERDUE_PAYABLES',
  // User Management Module
  USER_GROUPS: 'USER_GROUPS',
  USER_ROLES: 'USER_ROLES',
  USER_LEVELS: 'USER_LEVELS',
  USER_PROFILES: 'USER_PROFILES',
  USER_CREATION: 'USER_CREATION',
  USER_PRIVILEGES: 'USER_PRIVILEGES',
  MODULE_MASTER: 'MODULE_MASTER',
  SUBMODULE_MASTER: 'SUBMODULE_MASTER',
  SCREEN_MASTER: 'SCREEN_MASTER',
  DAY_OPEN: 'DAY_OPEN',
  DAY_CLOSE: 'DAY_CLOSE',
  // POS Module (6.x)
  FLOOR_MASTER: 'FLOOR_MASTER',
  COUNTER_MASTER: 'COUNTER_MASTER',
  PLACE_MASTER: 'PLACE_MASTER',
  SHIFT_MASTER: 'SHIFT_MASTER',
  SALESMAN_MASTER: 'SALESMAN_MASTER',
  CUSTOMER_MASTER: 'CUSTOMER_MASTER',
  PAYMENT_MASTER: 'PAYMENT_MASTER',
  PROMOTION_MASTER: 'PROMOTION_MASTER',
  TELLER_MASTER: 'TELLER_MASTER',
  SALES_DIVISION_MASTER: 'SALES_DIVISION_MASTER',
  BRANCH_WISE_PROMOTIONS: 'BRANCH_WISE_PROMOTIONS',

  // Foundation
  ENTERPRISE_ACCOUNT: 'ENTERPRISE_ACCOUNT',
  GROUP_COMPANY: 'GROUP_COMPANY',
  COMPANY_MASTER: 'COMPANY_MASTER',
  BRANCH_MASTER: 'BRANCH_MASTER',
  WAREHOUSE_MASTER: 'WAREHOUSE_MASTER',
  CURRENCY_MASTER: 'CURRENCY_MASTER',
  FORM_BUILDER: 'FORM_BUILDER',
  SALES_ORDER: 'SALES_ORDER',
  DELIVERY_CHALLAN: 'DELIVERY_CHALLAN',
  DC_RETURNS: 'DC_RETURNS',
  SALES_INVOICE: 'SALES_INVOICE',
  POS_BILLING: 'POS_BILLING',
  CASH_COUNTER_BILLING: 'CASH_COUNTER_BILLING',
  SALES_INVOICE_RETURNS: 'SALES_INVOICE_RETURNS',
  // POS Reports (6.9.x)
  POS_SALES_SUMMARY: 'POS_SALES_SUMMARY',
  POS_BILL_TO_BILL: 'POS_BILL_TO_BILL',

  // ── New Industry POS Screens (6.16.x) ────────────────────────────────────
  APPAREL_POS: 'APPAREL_POS',           // 6.16.11 Apparel / Retail POS
  SUPERMARKET_POS: 'SUPERMARKET_POS',   // 6.16.12 Supermarket POS
  FRESH_VEG_POS: 'FRESH_VEG_POS',      // 6.16.13 Fresh / Veg Counter POS
  FOOD_COURT_POS: 'FOOD_COURT_POS',    // 6.16.14 Food Court / Restaurant POS

  // ── GRN Screens (4.8.x — from USER_SCREENS DB) ───────────────────────────
  // Correct IDs from production DB:
  GRN_AGAINST_PO_SCREEN: 'GRN_AGAINST_PO_SCREEN', // 4.8.14 GRN Against Purchase Order (New UI)
  GRN_AGAINST_PI_SCREEN: 'GRN_AGAINST_PI_SCREEN', // 4.8.15 GRN Against Proforma Invoice (New UI)
  GRN_RETURN_SCREEN: 'GRN_RETURN_SCREEN',         // 4.8.16 GRN Return (New UI)
  PI_RETURN_NEW: 'PI_RETURN_NEW',                 // 4.8.17 Purchase Invoice Return (New UI)

  // ── GRC Screens (4.8.x / 4.21.x — Goods Receipt Challan) ─────────────────
  GRC_DIRECT_SCREEN: 'GRC_DIRECT_SCREEN',               // 4.8.1  GRC Direct
  GRC_AGST_PO_SCREEN: 'GRC_AGST_PO_SCREEN',             // 4.8.2  GRC Against PO
  GRC_TEMPLATE_SCREEN: 'GRC_TEMPLATE_SCREEN',           // 4.8.3  GRC Template
  GRC_RETURNS_CHALLAN_SCREEN: 'GRC_RETURNS_CHALLAN_SCREEN', // 4.8.5  Goods Returns Challan
  GRC_RETURN_AGST_GRC_SCREEN: 'GRC_RETURN_AGST_GRC_SCREEN', // 4.8.6  Goods Return Against GRC
  GRC_RETURNS_PACKING_SCREEN: 'GRC_RETURNS_PACKING_SCREEN', // 4.8.8  Goods Returns Packing List
  GRC_GARMENTS_SCREEN: 'GRC_GARMENTS_SCREEN',           // 4.8.13 GRC Garments
  GRC_AGST_PB_SCREEN: 'GRC_AGST_PB_SCREEN',             // 4.21.5 GRC Against Party Bill
  
  // ═══════════════════════════════════════════════════════════════════════════
  // PROCUREMENT MODULE (4.x)
  // ═══════════════════════════════════════════════════════════════════════════
  // Masters (4.1.x)
  SUPPLIER_MASTER: 'SUPPLIER_MASTER',
  SUPPLIER_CONTRACTS: 'SUPPLIER_CONTRACTS',
  AGENT_MASTER: 'AGENT_MASTER',
  JOBBER_MASTER: 'JOBBER_MASTER',
  TRANSPORTER_MASTER: 'TRANSPORTER_MASTER',
  TAX_GROUP_MASTER: 'TAX_GROUP_MASTER',
  TAX_MASTER: 'TAX_MASTER',
  TAILOR_MASTER: 'TAILOR_MASTER',
  UOM_MASTER: 'UOM_MASTER',
  SUB_UOM_MASTER: 'SUB_UOM_MASTER',
  PURCHASE_OFFICER_MASTER: 'PURCHASE_OFFICER_MASTER',
  DEFAULT_VERTICALS: 'DEFAULT_VERTICALS',
  SALES_PRICE_FORMULA: 'SALES_PRICE_FORMULA',
  MANUFACTURER_MASTER: 'MANUFACTURER_MASTER',
  SETTING_PRICE_LEVEL: 'SETTING_PRICE_LEVEL',
  ITEM_BARCODE_GENERATION: 'ITEM_BARCODE_GENERATION',
  HSN_CODE_MASTER: 'HSN_CODE_MASTER',
  // Item Attributes (4.3.x)
  DIVISION_MASTER: 'DIVISION_MASTER',
  DEPARTMENT_MASTER: 'DEPARTMENT_MASTER',
  CATEGORY_MASTER: 'CATEGORY_MASTER',
  SUBCATEGORY_MASTER: 'SUBCATEGORY_MASTER',
  BRAND_MASTER: 'BRAND_MASTER',
  STYLE_MASTER: 'STYLE_MASTER',
  SIZE_MASTER: 'SIZE_MASTER',
  COLOR_MASTER: 'COLOR_MASTER',
  DESIGN_MASTER: 'DESIGN_MASTER',
  MATERIAL_MASTER: 'MATERIAL_MASTER',
  MASTER_PLAN: 'MASTER_PLAN',
  // Orders (4.4.x)
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  PURCHASE_ORDER_CANCEL: 'PURCHASE_ORDER_CANCEL',
  PURCHASE_ORDER_STATUS: 'PURCHASE_ORDER_STATUS',
  PO_PENDING_QTY_CANCEL: 'PO_PENDING_QTY_CANCEL',
  // Production (4.5.x)
  PO_CANCEL_REPORT: 'PO_CANCEL_REPORT',
  PO_SUMMARY_REPORT: 'PO_SUMMARY_REPORT',
  PO_SEARCH: 'PO_SEARCH',
  PO_EXCESS_REPORT: 'PO_EXCESS_REPORT',
  PO_PENDING_QTY_CANCEL_REPORT: 'PO_PENDING_QTY_CANCEL_REPORT',
  PROCESS_CREATION: 'PROCESS_CREATION',
  PRODUCTION_ORDER: 'PRODUCTION_ORDER',
  PRODUCTION_ESTIMATION: 'PRODUCTION_ESTIMATION',
  // Job Work (4.6.x)
  BILL_OF_MATERIAL: 'BILL_OF_MATERIAL',
  STOCK_ORDER: 'STOCK_ORDER',
  INWARD_JOB_WORK: 'INWARD_JOB_WORK',
  ISSUE_TO_JOBBER: 'ISSUE_TO_JOBBER',
  ISSUE_TO_JOBBER_NEW: 'ISSUE_TO_JOBBER_NEW',
  RECEIPT_FROM_JOBBER: 'RECEIPT_FROM_JOBBER',
  FINISHED_PRODUCT_PREPARATION: 'FINISHED_PRODUCT_PREPARATION',
  // Packing Moving (4.7.x)
  INWARD_WAREHOUSE: 'INWARD_WAREHOUSE',
  WAREHOUSE_RETURNS: 'WAREHOUSE_RETURNS',
  ISSUE_FOR_PACKAGES: 'ISSUE_FOR_PACKAGES',
  FINISHED_PACKING_GOODS: 'FINISHED_PACKING_GOODS',
  WASTAGE_MATERIAL: 'WASTAGE_MATERIAL',
  PRINT_BARCODE_LABEL: 'PRINT_BARCODE_LABEL',
  REPRINT_BARCODE_LABEL: 'REPRINT_BARCODE_LABEL',
  INWARD_BARCODE_LABEL: 'INWARD_BARCODE_LABEL',
  // GRN (4.8.x)
  GOODS_RECEIPTS: 'GOODS_RECEIPTS',
  GRC_DIRECT: 'GRC_DIRECT',
  GRC_GENERAL: 'GRC_GENERAL',
  GRC_AGAINST_PO: 'GRC_AGAINST_PO',
  GOODS_RECEIPT_CHALLAN: 'GOODS_RECEIPT_CHALLAN',
  ITEM_WISE_PRICE_UPDATE: 'ITEM_WISE_PRICE_UPDATE',
  // Reports (4.9.x)
  JOB_PROCESS_ISSUE_REPORT: 'JOB_PROCESS_ISSUE_REPORT',
  JOBBER_RECEIPT_REPORT: 'JOBBER_RECEIPT_REPORT',
  PROCESS_LEDGER_REPORT: 'PROCESS_LEDGER_REPORT',
  PURCHASE_DISCOUNT_REPORT: 'PURCHASE_DISCOUNT_REPORT',
  PURCHASE_INVOICE_AGST_GRC: 'PURCHASE_INVOICE_AGST_GRC',
  PURCHASE_INVOICE_AGST_PO: 'PURCHASE_INVOICE_AGST_PO',
  PURCHASE_INVOICE_REPORT: 'PURCHASE_INVOICE_REPORT',
  PURCHASE_RETURNS_REGISTER: 'PURCHASE_RETURNS_REGISTER',
  PURCHASE_TAX_REGISTER: 'PURCHASE_TAX_REGISTER',
  MONTHLY_RETURNS_VAT: 'MONTHLY_RETURNS_VAT',
  PURCHASE_INVOICE_WITH_RETURNS: 'PURCHASE_INVOICE_WITH_RETURNS',
  OPENING_STOCK_IMPORT_REPORT: 'OPENING_STOCK_IMPORT_REPORT',
  PARTY_BILL: 'PARTY_BILL',
  PARTY_BILL_RETURNS: 'PARTY_BILL_RETURNS',
  
  // ═══════════════════════════════════════════════════════════════════════════
  // INVENTORY MODULE (5.x)
  // ═══════════════════════════════════════════════════════════════════════════
  // Stock Verify (5.1.x)
  STOCK_VERIFY_SCHEDULE: 'STOCK_VERIFY_SCHEDULE',
  STOCK_VERIFY_ENTRY: 'STOCK_VERIFY_ENTRY',
  VERIFY_UPDATE_STOCK: 'VERIFY_UPDATE_STOCK',
  SHORTAGE_STOCK: 'SHORTAGE_STOCK',
  EXCESS_STOCK: 'EXCESS_STOCK',
  SHORTAGE_EXCESS_REPORT: 'SHORTAGE_EXCESS_REPORT',
  STOCK_VERIFY_ENTRY_MANUAL: 'STOCK_VERIFY_ENTRY_MANUAL',
  PHYSICAL_STOCK_PDA: 'PHYSICAL_STOCK_PDA',
  PHYSICAL_STOCK_SCAN_REPORT: 'PHYSICAL_STOCK_SCAN_REPORT',
  // Requirements (5.2.x)
  ROL_SETTINGS_NEW: 'ROL_SETTINGS_NEW',
  REORDER_LEVEL_REPORT: 'REORDER_LEVEL_REPORT',
  PRICE_UPDATE: 'PRICE_UPDATE',
  TOKEN_UPDATE: 'TOKEN_UPDATE',
  BULK_PRODUCT_UPDATION: 'BULK_PRODUCT_UPDATION',
  OEM_CODE_UPDATE: 'OEM_CODE_UPDATE',
  GENERAL_TOKEN_UPDATE: 'GENERAL_TOKEN_UPDATE',
  ITEM_CONVERSION: 'ITEM_CONVERSION',
  ITEM_CONVERSION_REPORT: 'ITEM_CONVERSION_REPORT',
  TALLY_INTEGRATION_AGST_BILLS: 'TALLY_INTEGRATION_AGST_BILLS',
  ASSIGN_TO_FLOOR_RACK: 'ASSIGN_TO_FLOOR_RACK',
  HSN_CODE_UPDATE: 'HSN_CODE_UPDATE',
  // Barcode (5.3.x)
  PRICE_PRINT_BARCODE: 'PRICE_PRINT_BARCODE',
  PRICE_REPRINT_BARCODE: 'PRICE_REPRINT_BARCODE',
  // Stock Reports (5.4.x)
  STOCK_MOVEMENT: 'STOCK_MOVEMENT',
  MONTHLY_STOCK_MOVEMENT: 'MONTHLY_STOCK_MOVEMENT',
  STOCK_LEDGER: 'STOCK_LEDGER',
  CLOSING_STOCK: 'CLOSING_STOCK',
  STOCK_ANALYSIS_REPORT: 'STOCK_ANALYSIS_REPORT',
  PILOT_STOCK_SALES_REPORT: 'PILOT_STOCK_SALES_REPORT',
  BARCODE_ITEM_INFORMATION: 'BARCODE_ITEM_INFORMATION',
  PRICE_UPDATE_REPORT: 'PRICE_UPDATE_REPORT',
  TOKEN_UPDATE_REPORT: 'TOKEN_UPDATE_REPORT',
  BULK_PRODUCT_UPDATION_REPORT: 'BULK_PRODUCT_UPDATION_REPORT',
  OEM_CODE_UPDATION_REPORT: 'OEM_CODE_UPDATION_REPORT',
  PACKED_ITEMS_STOCK_REPORT: 'PACKED_ITEMS_STOCK_REPORT',
  CLOSING_STOCK_WITH_PURCHASE: 'CLOSING_STOCK_WITH_PURCHASE',
  CLOSING_STOCK_AUDITOR: 'CLOSING_STOCK_AUDITOR',
  STOCK_LEDGER_WITH_DC: 'STOCK_LEDGER_WITH_DC',
  CLOSING_STOCK_WITH_DC: 'CLOSING_STOCK_WITH_DC',
  CLOSING_STOCK_IMAGE_REPORT: 'CLOSING_STOCK_IMAGE_REPORT',
  FLOOR_RACK_REPORT: 'FLOOR_RACK_REPORT',
  FLOOR_WISE_CLOSING_STOCK_REPORT: 'FLOOR_WISE_CLOSING_STOCK_REPORT',
  STOCK_TRACKING_REPORT: 'STOCK_TRACKING_REPORT',
  FINANCIAL_YEAR_DETAIL_REPORT: 'FINANCIAL_YEAR_DETAIL_REPORT',
  CUSTOMER_WISE_FAST_MOVING_SALES: 'CUSTOMER_WISE_FAST_MOVING_SALES',
  // Purchase Info (5.5.x)
  PURCHASE_SUMMARY_REPORTS: 'PURCHASE_SUMMARY_REPORTS',
  PURCHASE_PARTY_INFO: 'PURCHASE_PARTY_INFO',
  INVOICE_WISE_OUTSTANDING_REPORT: 'INVOICE_WISE_OUTSTANDING_REPORT',
  SUPPLIER_WISE_AGEING_REPORT: 'SUPPLIER_WISE_AGEING_REPORT',
  SOR_SUPPLIER_WISE_SALES_REPORT: 'SOR_SUPPLIER_WISE_SALES_REPORT',
  CITY_WISE_OUTSTANDING_PAYABLES: 'CITY_WISE_OUTSTANDING_PAYABLES',
  CITY_WISE_OUTSTANDING_RECEIVABLES: 'CITY_WISE_OUTSTANDING_RECEIVABLES',
  // Transfers (5.6.x)
  OPENING_STOCK_IMPORT: 'OPENING_STOCK_IMPORT',
  OPENING_STOCK_IMPORT_WITH_SUPPLIER: 'OPENING_STOCK_IMPORT_WITH_SUPPLIER',
  MATERIAL_RECEIPT_IMPORT_DIRECT: 'MATERIAL_RECEIPT_IMPORT_DIRECT',
  STOCK_EXPORT_TO_BRANCH: 'STOCK_EXPORT_TO_BRANCH',
  STOCK_RETURN_FROM_BRANCH_OFFLINE: 'STOCK_RETURN_FROM_BRANCH_OFFLINE',
  STOCK_RETURN_FROM_BRANCH_ONLINE: 'STOCK_RETURN_FROM_BRANCH_ONLINE',
  STOCK_RETURN_IMPORT_AT_WAREHOUSE: 'STOCK_RETURN_IMPORT_AT_WAREHOUSE',
  STOCK_RETURN_TO_WAREHOUSE: 'STOCK_RETURN_TO_WAREHOUSE',
  STOCK_IMPORT_FROM_WAREHOUSE_OFFLINE: 'STOCK_IMPORT_FROM_WAREHOUSE_OFFLINE',
  STOCK_IMPORT_FROM_WAREHOUSE_ONLINE: 'STOCK_IMPORT_FROM_WAREHOUSE_ONLINE',
  BRANCH_OPENING_STOCK_IMPORT: 'BRANCH_OPENING_STOCK_IMPORT',
  SALES_EXPORT_TO_WAREHOUSE: 'SALES_EXPORT_TO_WAREHOUSE',
  SALES_EXPORT_TO_EXCEL: 'SALES_EXPORT_TO_EXCEL',
  SALES_IMPORT_FROM_EXCEL: 'SALES_IMPORT_FROM_EXCEL',
  PHYSICAL_STOCK_EXPORT_TO_WH: 'PHYSICAL_STOCK_EXPORT_TO_WH',
  // Branch Reports (5.7.x)
  BRANCH_STOCK_MOVEMENT: 'BRANCH_STOCK_MOVEMENT',
  BRANCH_WISE_STOCK: 'BRANCH_WISE_STOCK',
  STOCK_TRANSFER_REPORT: 'STOCK_TRANSFER_REPORT',
  BRANCH_POS_INFO: 'BRANCH_POS_INFO',
  SUPPLIER_WISE_PURCHASE_ORDER_REPORT: 'SUPPLIER_WISE_PURCHASE_ORDER_REPORT',
  BRANCH_BILL_TO_BILL_REPORT: 'BRANCH_BILL_TO_BILL_REPORT',
  BRANCH_BULK_INVOICE_PRINT_REPORT: 'BRANCH_BULK_INVOICE_PRINT_REPORT',
  BRANCH_DAY_SHEET_REPORT: 'BRANCH_DAY_SHEET_REPORT',
  BRANCH_POS_CANCEL_REPORT: 'BRANCH_POS_CANCEL_REPORT',
  BRANCH_TAX_REGISTER: 'BRANCH_TAX_REGISTER',
  BRANCH_CUSTOMER_SALES_REPORT: 'BRANCH_CUSTOMER_SALES_REPORT',
  BRANCH_PRODUCT_AGEING: 'BRANCH_PRODUCT_AGEING',
  BRANCH_FAST_MOVING_ITEMS: 'BRANCH_FAST_MOVING_ITEMS',
  BRANCH_EOD_REPORT: 'BRANCH_EOD_REPORT',
  // Franchise (5.8.x)
  STOCK_EXPORT_TO_FRANCHISE: 'STOCK_EXPORT_TO_FRANCHISE',
  STOCK_IMPORT_FROM_FRANCHISE: 'STOCK_IMPORT_FROM_FRANCHISE',
  STOCK_IMPORT_AT_FRANCHISE_ONLINE: 'STOCK_IMPORT_AT_FRANCHISE_ONLINE',
  FRANCHISE_BARCODE_PRINT: 'FRANCHISE_BARCODE_PRINT',
  STOCK_RETURN_AT_FRANCHISE_ONLINE: 'STOCK_RETURN_AT_FRANCHISE_ONLINE',
  FRANCHISE_SALES_IMPORT: 'FRANCHISE_SALES_IMPORT',
  STOCK_EXPORT_REPORT: 'STOCK_EXPORT_REPORT',
  FRANCHISE_SALES_SUMMARY: 'FRANCHISE_SALES_SUMMARY',
  FRANCHISE_STOCK_AND_SALES_REPORT: 'FRANCHISE_STOCK_AND_SALES_REPORT',
  FRANCHISE_SALES: 'FRANCHISE_SALES',
  GROUP_WISE_FRANCHISE_SALES: 'GROUP_WISE_FRANCHISE_SALES',
  FRANCHISE_PRODUCT_PROFITABILITY: 'FRANCHISE_PRODUCT_PROFITABILITY',
  FRANCHISE_INVOICE_REPORT: 'FRANCHISE_INVOICE_REPORT',
  FRANCHISE_MARKDOWN_PROFIT_REPORT: 'FRANCHISE_MARKDOWN_PROFIT_REPORT',
  // Shop (5.9.x)
  STOCK_TRANSFER_TO_SHOP: 'STOCK_TRANSFER_TO_SHOP',
  STOCK_RETURN_FROM_SHOP: 'STOCK_RETURN_FROM_SHOP',
  SHOP_BARCODE_PRINT: 'SHOP_BARCODE_PRINT',
  SALES_IMPORT_FROM_SHOP: 'SALES_IMPORT_FROM_SHOP',
  SHOP_STOCK_TRANSFER_REPORT: 'SHOP_STOCK_TRANSFER_REPORT',
  SIS_POS_INFO: 'SIS_POS_INFO',
  SIS_SALES: 'SIS_SALES',
  // MIS Reports (5.10.x)
  PRODUCT_PROFITABILITY: 'PRODUCT_PROFITABILITY',
  PRODUCT_AGEING: 'PRODUCT_AGEING',
  FAST_MOVING_ITEMS: 'FAST_MOVING_ITEMS',
  EXPIRY_ITEMS: 'EXPIRY_ITEMS',
  SUPPLIER_PERFORMANCE: 'SUPPLIER_PERFORMANCE',
  PURCHASE_PROFITABILITY: 'PURCHASE_PROFITABILITY',
  MRP_WISE_PURCHASE_SALES_REPORT: 'MRP_WISE_PURCHASE_SALES_REPORT',
  SM_PRODUCT_PROFITABILITY: 'SM_PRODUCT_PROFITABILITY',
  PRODUCT_PROFITABILITY_NEW: 'PRODUCT_PROFITABILITY_NEW',

  // ═══════════════════════════════════════════════════════════════════════════
  // PROCUREMENT MODULE - NEW SCREENS (4.10.x - 4.22.x)
  // ═══════════════════════════════════════════════════════════════════════════
  // Purchase Invoice (4.10.x)
  PURCHASE_INVOICE_AGST_GRC_SCREEN: 'PURCHASE_INVOICE_AGST_GRC_SCREEN',
  PURCHASE_INVOICE_AGST_PO_SCREEN: 'PURCHASE_INVOICE_AGST_PO_SCREEN',
  PURCHASE_INVOICE_SCREEN: 'PURCHASE_INVOICE_SCREEN',
  PURCHASE_RETURNS_SCREEN: 'PURCHASE_RETURNS_SCREEN',
  PURCHASE_INVOICE_MULTI_DISCOUNTS: 'PURCHASE_INVOICE_MULTI_DISCOUNTS',
  BULK_PURCHASE_RETURNS: 'BULK_PURCHASE_RETURNS',
  
  // Gift Items (4.11.x)
  STOCK_TO_GIFT_ITEMS_CONVERSION: 'STOCK_TO_GIFT_ITEMS_CONVERSION',
  ASSIGN_GIFT_ITEM_TO_ITEMS: 'ASSIGN_GIFT_ITEM_TO_ITEMS',
  GIFT_ITEM_STATUS_REPORT: 'GIFT_ITEM_STATUS_REPORT',
  
  // GRC Operations (4.12.x)
  GRC_GOODS_RECEIPT_CHALLAN: 'GRC_GOODS_RECEIPT_CHALLAN',
  GRC_AGST_PO: 'GRC_AGST_PO',
  GRC_TEMPLATE: 'GRC_TEMPLATE',
  GOODS_RETURNS_AGST_PO: 'GOODS_RETURNS_AGST_PO',
  GOODS_RETURNS_AGST_GRC: 'GOODS_RETURNS_AGST_GRC',
  GRC_PURCHASE_DISCOUNT_REPORT: 'GRC_PURCHASE_DISCOUNT_REPORT',
  GOODS_RETURNS_PACKING_REGISTER: 'GOODS_RETURNS_PACKING_REGISTER',
  
  // PO Reports (4.13.x)
  PURCHASE_ORDER_REGISTER: 'PURCHASE_ORDER_REGISTER',
  PURCHASE_ORDER_TEMPLATE_REGISTER: 'PURCHASE_ORDER_TEMPLATE_REGISTER',
  PURCHASE_ORDER_CANCEL_REGISTER: 'PURCHASE_ORDER_CANCEL_REGISTER',
  
  // Purchase Reports (4.14.x)
  PURCHASE_INVOICE_AGST_GRC_REPORT: 'PURCHASE_INVOICE_AGST_GRC_REPORT',
  PURCHASE_INVOICE_AGST_PO_REPORT: 'PURCHASE_INVOICE_AGST_PO_REPORT',
  PURCHASE_INVOICE_REPORT_SCREEN: 'PURCHASE_INVOICE_REPORT_SCREEN',
  PURCHASE_RETURNS_REGISTER_SCREEN: 'PURCHASE_RETURNS_REGISTER_SCREEN',
  PURCHASE_INVOICE_WITH_RETURNS_SCREEN: 'PURCHASE_INVOICE_WITH_RETURNS_SCREEN',
  SERVICE_INVOICE_REGISTER: 'SERVICE_INVOICE_REGISTER',
  PURCHASE_TAX_REGISTER_SCREEN: 'PURCHASE_TAX_REGISTER_SCREEN',
  MONTHLY_RETURN_FOR_VAT: 'MONTHLY_RETURN_FOR_VAT',
  OPENING_STOCK_IMPORT_REPORT_SCREEN: 'OPENING_STOCK_IMPORT_REPORT_SCREEN',
  
  // Job Work (4.15.x)
  BILL_OF_MATERIAL_SCREEN: 'BILL_OF_MATERIAL_SCREEN',
  STOCK_ORDER_SCREEN: 'STOCK_ORDER_SCREEN',
  ISSUE_TO_JOBBER_SCREEN: 'ISSUE_TO_JOBBER_SCREEN',
  RECEIPT_FROM_JOBBER_SCREEN: 'RECEIPT_FROM_JOBBER_SCREEN',
  STOCK_ORDER_STATUS: 'STOCK_ORDER_STATUS',
  ISSUE_TO_JOBBER_REPORT: 'ISSUE_TO_JOBBER_REPORT',
  RECEIPT_FROM_JOBBER_REPORT: 'RECEIPT_FROM_JOBBER_REPORT',
  INWARD_JOB_WORK_SCREEN: 'INWARD_JOB_WORK_SCREEN',
  INWARD_WAREHOUSE_REPORT: 'INWARD_WAREHOUSE_REPORT',
  FINISHED_PACKING_CONSUMPTION: 'FINISHED_PACKING_CONSUMPTION',
  ISSUE_TO_JOBBER_NEW_SCREEN: 'ISSUE_TO_JOBBER_NEW_SCREEN',
  RETURNS_FROM_JOBBER: 'RETURNS_FROM_JOBBER',
  RETURNS_FROM_JOBBER_REPORT: 'RETURNS_FROM_JOBBER_REPORT',
  
  // Packing Moving (4.16.x)
  INWARD_WAREHOUSE_SCREEN: 'INWARD_WAREHOUSE_SCREEN',
  WAREHOUSE_RETURNS_SCREEN: 'WAREHOUSE_RETURNS_SCREEN',
  ISSUE_FOR_PACKAGES_SCREEN: 'ISSUE_FOR_PACKAGES_SCREEN',
  FINISHED_PACKING_GOODS_SCREEN: 'FINISHED_PACKING_GOODS_SCREEN',
  PKG_INWARD_WAREHOUSE_REPORT: 'PKG_INWARD_WAREHOUSE_REPORT',
  PKG_WAREHOUSE_RETURN_REPORT: 'PKG_WAREHOUSE_RETURN_REPORT',
  PKG_ISSUE_STOCK_REPORT: 'PKG_ISSUE_STOCK_REPORT',
  FINISHED_PACKING_GOODS_REPORT: 'FINISHED_PACKING_GOODS_REPORT',
  WASTAGE_MATERIAL_SCREEN: 'WASTAGE_MATERIAL_SCREEN',
  PACKING_GIFT: 'PACKING_GIFT',
  WASTAGE_MATERIAL_REPORT: 'WASTAGE_MATERIAL_REPORT',
  
  // Print Barcode (4.17.x)
  PRINT_BARCODE_LABEL_SCREEN: 'PRINT_BARCODE_LABEL_SCREEN',
  REPRINT_BARCODE_LABEL_SCREEN: 'REPRINT_BARCODE_LABEL_SCREEN',
  INWARD_BARCODE_LABEL_SCREEN: 'INWARD_BARCODE_LABEL_SCREEN',
  
  // Production (4.18.x)
  PROCESS_CREATION_SCREEN: 'PROCESS_CREATION_SCREEN',
  JOB_PROCESS_ISSUE: 'JOB_PROCESS_ISSUE',
  JOBBER_RECEIPT: 'JOBBER_RECEIPT',
  
  // Production Reports (4.19.x)
  JOB_PROCESS_ISSUE_REPORT_SCREEN: 'JOB_PROCESS_ISSUE_REPORT_SCREEN',
  GOODS_RECEIVE_REPORT: 'GOODS_RECEIVE_REPORT',
  PROCESS_LEDGER_REPORT_SCREEN: 'PROCESS_LEDGER_REPORT_SCREEN',
  
  // Production Order (4.20.x)
  PRODUCTION_ORDER_SCREEN: 'PRODUCTION_ORDER_SCREEN',
  
  // Party Bill (4.21.x)
  PARTY_BILL_SCREEN: 'PARTY_BILL_SCREEN',
  PURCHASE_INVOICE_AGST_PB: 'PURCHASE_INVOICE_AGST_PB',
  PARTY_BILL_RETURNS_SCREEN: 'PARTY_BILL_RETURNS_SCREEN',
  PENDING_PB_CANCEL: 'PENDING_PB_CANCEL',
  GRC_AGST_PB: 'GRC_AGST_PB',
  
  // Party Bill Reports (4.22.x)
  PARTY_BILL_REPORT: 'PARTY_BILL_REPORT',
  PURCHASE_INVOICE_AGST_PB_REPORT: 'PURCHASE_INVOICE_AGST_PB_REPORT',
  PARTY_BILL_RETURN_REPORT: 'PARTY_BILL_RETURN_REPORT',
  PENDING_PB_CANCEL_REPORT: 'PENDING_PB_CANCEL_REPORT',
  PARTY_BILL_STATUS_REPORT: 'PARTY_BILL_STATUS_REPORT',
  PARTY_BILL_WISE_AGEING_REPORT: 'PARTY_BILL_WISE_AGEING_REPORT',
  GRC_AGST_PB_REPORT: 'GRC_AGST_PB_REPORT',

  // ═══════════════════════════════════════════════════════════════════════════
  // INVENTORY MODULE - NEW SCREENS (5.x)
  // ═══════════════════════════════════════════════════════════════════════════
  // Branch Reports (5.13.x)
  BRANCH_STOCK_MOVEMENT_SCREEN: 'BRANCH_STOCK_MOVEMENT_SCREEN',
  BRANCHWISE_STOCK: 'BRANCHWISE_STOCK',
  STOCK_IMPORT_EXPORT: 'STOCK_IMPORT_EXPORT',
  BRANCH_POS_INFO_SCREEN: 'BRANCH_POS_INFO_SCREEN',
  SUPPLIERWISE_PURCHASE_ORDER_REPORT: 'SUPPLIERWISE_PURCHASE_ORDER_REPORT',
  BRANCH_BILL_TO_BILL_REPORT_SCREEN: 'BRANCH_BILL_TO_BILL_REPORT_SCREEN',
  BRANCH_BULK_INVOICE_PRINT_REPORT_SCREEN: 'BRANCH_BULK_INVOICE_PRINT_REPORT_SCREEN',
  BRANCH_DAY_SHEET_REPORT_SCREEN: 'BRANCH_DAY_SHEET_REPORT_SCREEN',
  
  // Franchise (5.14.x)
  STOCK_EXPORT_TO_FRANCHISE_SCREEN: 'STOCK_EXPORT_TO_FRANCHISE_SCREEN',
  STOCK_IMPORT_FROM_FRANCHISE_SCREEN: 'STOCK_IMPORT_FROM_FRANCHISE_SCREEN',
  FRANCHISE_BARCODE_PRINT_SCREEN: 'FRANCHISE_BARCODE_PRINT_SCREEN',
  STOCK_IMPORT_AT_FRANCHISE_ONLINE_SCREEN: 'STOCK_IMPORT_AT_FRANCHISE_ONLINE_SCREEN',
  STOCK_RETURN_AT_FRANCHISE_ONLINE_SCREEN: 'STOCK_RETURN_AT_FRANCHISE_ONLINE_SCREEN',
  
  // Franchise Reports (5.16.x)
  FRANCHISE_TRANSFER_REPORT: 'FRANCHISE_TRANSFER_REPORT',
  BILLWISE_TAX_REGISTER: 'BILLWISE_TAX_REGISTER',
  STOCK_EXPORT_REPORT_SCREEN: 'STOCK_EXPORT_REPORT_SCREEN',
  FRANCHISE_SALES_SUMMARY_SCREEN: 'FRANCHISE_SALES_SUMMARY_SCREEN',
  FRANCHISE_STOCK_AND_SALES_REPORT_SCREEN: 'FRANCHISE_STOCK_AND_SALES_REPORT_SCREEN',
  FRANCHISE_PRODUCT_PROFITABILITY_SCREEN: 'FRANCHISE_PRODUCT_PROFITABILITY_SCREEN',
  FRANCHISE_INVOICE_REPORT_SCREEN: 'FRANCHISE_INVOICE_REPORT_SCREEN',
  FRANCHISE_MARKDOWN_PROFIT_REPORT_SCREEN: 'FRANCHISE_MARKDOWN_PROFIT_REPORT_SCREEN',
  
  // Shop (5.17.x)
  STOCK_TRANSFER_TO_SHOP_SCREEN: 'STOCK_TRANSFER_TO_SHOP_SCREEN',
  STOCK_RETURN_FROM_SHOP_SCREEN: 'STOCK_RETURN_FROM_SHOP_SCREEN',
  SHOP_BARCODE_PRINT_SCREEN: 'SHOP_BARCODE_PRINT_SCREEN',
  
  // SIS (5.19.x)
  SIS_STOCK_IMPORT: 'SIS_STOCK_IMPORT',
  SIS_POS_INFO_SCREEN: 'SIS_POS_INFO_SCREEN',
  SIS_GROUP_WISE_SALES_REPORT: 'SIS_GROUP_WISE_SALES_REPORT',
  
  // Branch Transfers (5.20.x)
  STOCK_TRANSFER_TO_BRANCH_SCREEN: 'STOCK_TRANSFER_TO_BRANCH_SCREEN',
  STOCK_IMPORT_FROM_BRANCH_SCREEN: 'STOCK_IMPORT_FROM_BRANCH_SCREEN',
  STOCK_TRANSFER_REPORT_SCREEN: 'STOCK_TRANSFER_REPORT_SCREEN',
  BRANCH_SALES_SUMMARY: 'BRANCH_SALES_SUMMARY',

  // ═══════════════════════════════════════════════════════════════════════════
  // NEW SCREENS - GRC Operations (4.12.x)
  // ═══════════════════════════════════════════════════════════════════════════
  GRC_TEMPLATE: 'GRC_TEMPLATE',
  GOODS_RETURNS_AGST_PO: 'GOODS_RETURNS_AGST_PO',
  GOODS_RETURNS_AGST_GRC: 'GOODS_RETURNS_AGST_GRC',
  GRC_PURCHASE_DISCOUNT_REPORT: 'GRC_PURCHASE_DISCOUNT_REPORT',
  GOODS_RETURNS_PACKING_REGISTER: 'GOODS_RETURNS_PACKING_REGISTER',

  // PO Reports (4.13.x)
  PURCHASE_ORDER_REGISTER: 'PURCHASE_ORDER_REGISTER',
  PURCHASE_ORDER_TEMPLATE_REGISTER: 'PURCHASE_ORDER_TEMPLATE_REGISTER',
  PURCHASE_ORDER_CANCEL_REGISTER: 'PURCHASE_ORDER_CANCEL_REGISTER',

  // Purchase Reports (4.14.x)
  SERVICE_INVOICE_REGISTER: 'SERVICE_INVOICE_REGISTER',

  // Job Work New (4.15.x)
  STOCK_ORDER_STATUS: 'STOCK_ORDER_STATUS',
  ISSUE_TO_JOBBER_REPORT: 'ISSUE_TO_JOBBER_REPORT',
  RECEIPT_FROM_JOBBER_REPORT: 'RECEIPT_FROM_JOBBER_REPORT',
  INWARD_WAREHOUSE_REPORT: 'INWARD_WAREHOUSE_REPORT',
  FINISHED_PACKING_CONSUMPTION: 'FINISHED_PACKING_CONSUMPTION',
  RETURNS_FROM_JOBBER: 'RETURNS_FROM_JOBBER',
  RETURNS_FROM_JOBBER_REPORT: 'RETURNS_FROM_JOBBER_REPORT',

  // Packing Moving New (4.16.x)
  PKG_INWARD_WAREHOUSE_REPORT: 'PKG_INWARD_WAREHOUSE_REPORT',
  PKG_WAREHOUSE_RETURN_REPORT: 'PKG_WAREHOUSE_RETURN_REPORT',
  PKG_ISSUE_STOCK_REPORT: 'PKG_ISSUE_STOCK_REPORT',
  FINISHED_PACKING_GOODS_REPORT: 'FINISHED_PACKING_GOODS_REPORT',
  PACKING_GIFT: 'PACKING_GIFT',
  WASTAGE_MATERIAL_REPORT: 'WASTAGE_MATERIAL_REPORT',

  // Production New (4.18.x)
  JOB_PROCESS_ISSUE: 'JOB_PROCESS_ISSUE',
  JOBBER_RECEIPT: 'JOBBER_RECEIPT',

  // Production Reports (4.19.x)
  GOODS_RECEIVE_REPORT: 'GOODS_RECEIVE_REPORT',

  // Party Bill Reports (4.22.x)
  PARTY_BILL_REPORT: 'PARTY_BILL_REPORT',
  PURCHASE_INVOICE_AGST_PB_REPORT: 'PURCHASE_INVOICE_AGST_PB_REPORT',
  PARTY_BILL_RETURN_REPORT: 'PARTY_BILL_RETURN_REPORT',
  PENDING_PB_CANCEL_REPORT: 'PENDING_PB_CANCEL_REPORT',
  PARTY_BILL_STATUS_REPORT: 'PARTY_BILL_STATUS_REPORT',
  PARTY_BILL_WISE_AGEING_REPORT: 'PARTY_BILL_WISE_AGEING_REPORT',
  GRC_AGST_PB_REPORT: 'GRC_AGST_PB_REPORT',

  // ═══════════════════════════════════════════════════════════════════════════
  // NEW SCREENS - Inventory Masters New (5.5.x extended)
  // ═══════════════════════════════════════════════════════════════════════════
  INVENTORY_DIVISION_MASTER: 'INVENTORY_DIVISION_MASTER',
  INVENTORY_SIZE_MASTER: 'INVENTORY_SIZE_MASTER',
  INVENTORY_STYLE_MASTER: 'INVENTORY_STYLE_MASTER',
  INVENTORY_DEPARTMENT_MASTER: 'INVENTORY_DEPARTMENT_MASTER',
  SUB_CATEGORY_MASTER: 'SUB_CATEGORY_MASTER',
  INVENTORY_UOM_MASTER: 'INVENTORY_UOM_MASTER',
  INVENTORY_SUB_UOM_MASTER: 'INVENTORY_SUB_UOM_MASTER',

  // Transfers New (5.3.x extended)
  RECEIPT_FROM_BRANCH: 'RECEIPT_FROM_BRANCH',
  STOCK_IMPORT_FROM_BRANCH: 'STOCK_IMPORT_FROM_BRANCH',
  BRANCH_STOCK_IMPORT_FROM_WAREHOUSE: 'BRANCH_STOCK_IMPORT_FROM_WAREHOUSE',

  // Stock Reports New (5.4.x extended)
  ISSUE_TO_WAREHOUSE_REPORT: 'ISSUE_TO_WAREHOUSE_REPORT',
  RETURN_FROM_WAREHOUSE_REPORT: 'RETURN_FROM_WAREHOUSE_REPORT',
  RECEIPT_AT_BRANCH_REPORT: 'RECEIPT_AT_BRANCH_REPORT',
  ITEM_MOVEMENT_REPORT: 'ITEM_MOVEMENT_REPORT',
  ITEM_BARCODE_WISE_STOCK_REPORT: 'ITEM_BARCODE_WISE_STOCK_REPORT',
  STOCK_AGING_REPORT: 'STOCK_AGING_REPORT',
};
